import { FALLBACK_CID } from 'common/config';

export const getQueryParams = (): URLSearchParams => {
  if (typeof window !== 'undefined') {
    return new URLSearchParams(window.location.search);
  }

  return new URLSearchParams();
};

export const getQueryParamValue = (key: string): string => {
  const query = getQueryParams();
  return decodeURIComponent(query.get(key) as string).replace(' ', '+');
};

export const getCIDQueryParamValue = (): string => {
  const cid = getQueryParamValue('cid');
  if (cid === '' || cid === 'null') return FALLBACK_CID;
  return cid;
};
